import { Route, Routes } from 'react-router-dom';
import { Layout } from './components/Layout';
import { HomePage } from './pages/HomePage';
import { MarketplacePage } from './pages/MarketplacePage';
import { ProductPage } from './pages/ProductPage';
import { ServicesPage } from './pages/ServicesPage';
import { HowItWorksPage } from './pages/HowItWorksPage';
import { CheckoutDetailsPage } from './pages/CheckoutDetailsPage';
import { SuccessPage } from './pages/SuccessPage';
import { CancelPage } from './pages/CancelPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { QuickbooksN8nPrivacyPage } from './pages/QuickbooksN8nPrivacyPage';
import { QuickbooksEspoPrivacyPage } from './pages/QuickbooksEspoPrivacyPage';
import { EulaPage } from './pages/EulaPage';

export default function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<HomePage />} />
        <Route path="services" element={<ServicesPage />} />
        <Route path="how-it-works" element={<HowItWorksPage />} />
        <Route path="marketplace" element={<MarketplacePage />} />
        <Route path="marketplace/:slug" element={<ProductPage />} />
        <Route path="checkout/details" element={<CheckoutDetailsPage />} />
        <Route path="checkout/success" element={<SuccessPage />} />
        <Route path="checkout/cancel" element={<CancelPage />} />
        <Route path="privacy/quickbooks-n8n" element={<QuickbooksN8nPrivacyPage />} />
        <Route path="privacy/quickbooks-espocrm" element={<QuickbooksEspoPrivacyPage />} />
        <Route path="eula" element={<EulaPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}
